export const SET_LOADING='SET_LOADING'
export const SET_LOADING2='SET_LOADING2'

export const SET_TAB='SET_TAB'